<template>
  <div v-if="productData" class="col-12 advCartRow">
    <div v-if="miniCart">
      <div class="text-center minicartItem">
        <div class="row">
          <div class="col-3 minicart-item-thumb">
            <div class="thumbnail_container">
              <div class="thumbnail">
                <img class="img-fluid" :src="imageSrc" :alt="productData.productName"/>
              </div>
            </div>
          </div>
          <div class="col-9 cart_item_info">
            <div class="row">
              <button v-on:click="removeProductFromCart" :disabled="!onlineStatus" class="action-item rem-minicart-prod pt-0" v-if="!readOnly">
                <i class="lni lni-trash"></i>
              </button>
              <div class="col-12 cart_item_name">
                {{ productData.productName }}
              </div>
              <div class="col-6 text-left minicart-price">
                  <span>
                      {{ t('price') }}: <span v-html="finalTotalPriceWithSign"></span>
                  </span>
              </div>
              <div class="col-6 minicart-input-col" v-if="!readOnly">
                <div class="row">
                  <adv-cart-input-spinner
                    class="quantitySpinner"
                    :product-code-id="cartProduct.productCodeId"
                    :quantity="cartProduct.quantity"
                    v-on:quantity-changed="updateProductQuantity">
                  </adv-cart-input-spinner>
                </div>
              </div>
              <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
              <div class="col-12 text-left minicart-quantity" v-if="readOnly">
                  <span>
                    {{ t('quantity') }}: {{ cartProduct.quantity }}
                  </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!miniCart">
      <div class="row minicart-item-row">
        <div class="col-12 text-center helpCartMsg m-3" v-show="cartError && !readOnly">
          <span><i class="ti-info-alt"></i> {{ cartError }}</span>
        </div>
        <div class="col-2 minicart-item-thumb">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img :src="imageSrc" :alt="productData.productName">
            </div>
          </div>
        </div>
        <div class="col-10 col-sm-4 col-5 col-md-5 minicart-item-title text-left ">
          <a :href="productData.productUrl">
            {{ productData.productName }}
          </a>
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
          <div class="minicart-item-price text-left "><small>{{ t('price') }} / {{ t('package') }}:</small>
            <b><span v-html="finalPriceWithSign"></span></b>
            <small class="product-code-in-row"><span>Κωδ.προϊόντος: {{ cartProduct.productId }}</span></small>
          </div>
        </div>
        <div class="col-4 col-md-3 minicart-item-quantity" v-if="!readOnly">
          <adv-cart-input-spinner
            class="quantitySpinner"
            :product-code-id="cartProduct.productCodeId"
            :quantity="cartProduct.quantity"
            v-on:quantity-changed="updateProductQuantity">
          </adv-cart-input-spinner>
        </div>
        <div class="col-6 offset-2 col-sm-4 col-md-3 minicart-item-quantity advSpinnerRow" v-if="readOnly">
          {{ cartProduct.quantity }}
        </div>
        <div class="col-4 col-sm-12 col-md-2 advCartRowTotal">
          <div class="advCart-discount-row d-none" v-show="productData.productHasDiscount" >
            <small class="advCartDiscTtl">{{ t('discount') }}</small>
            <span class="advCartDiscPerc">
              <b>{{ productData.productDisclosure }}</b>
            </span>
          </div>
          <span v-show="productData.productHasDiscount" class="advCartPrevPrice d-none" v-html="originalTotalPriceWithSign"></span>
          <span class="advCartFinalPrice" v-html="finalTotalPriceWithSign"></span>
        </div>
        <a href="#" v-on:click="removeProductFromCart"  v-if="!readOnly" :disabled="!onlineStatus" class="action-item">
          <i class="lni lni-trash"></i>
        </a>
      </div>
      <div v-show="productCodeData.productCodeAttributes.length > 0" class="col-xs-12 advCartRowAttr">
          <span>
            {{ productCodeAttributes }}
          </span>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import onlineMixin from './mixins/onlineMixin'
import AdvCartInputSpinner from './AdvCartInputSpinner'
import AdvCartProductCustomizationDisplayValues
  from './cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'

export default {
  name: 'AdvCartProductRow',
  components: {
    AdvCartProductCustomizationDisplayValues,
    AdvCartInputSpinner
  },
  mixins: [onlineMixin],
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    cartProduct: {
      type: Object
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    cartError () {
      return store.getters.cartProductErrorMsg(this.cartProduct.productCodeId)
    },
    productCodeData () {
      return store.getters.getSelectedProductCodeByCodeId(this.cartProduct.productCodeId)
    },
    originalTotalPriceWithSign () {
      const price = this.productData.productOldPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalPriceWithSign () {
      return (this.productData.productFinalPrice * store.getters.getSelectedCurrency.rate).toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalTotalPriceWithSign () {
      const price = this.productData.productFinalPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    productData () {
      return store.getters.getProductById(this.cartProduct.productId)
    },
    imageSrc () {
      return this.productData.hasOwnProperty('images') ? this.productData.images[this.cartProduct.productCodeId].find(item => item.is_main === '1')['small'] : store.getters.noImage
    },
    productCodeAttributes () {
      return this.productCodeData.productCodeAttributes.reduce((acc, item) => {
        if (acc !== '') {
          acc += ' - '
        }

        acc += store.getters.attributeName(item)
        return acc
      }, '')
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    removeProductFromCart () {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity: 0
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    },
    updateProductQuantity (quantity) {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    }
  }
}
</script>
